import React, { useEffect, useState } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import { KatalogProgramComp } from '../../components';
import errorHandler from '../../helpers/errorHandler'
import axios from '../../lib/axios'
import './style.css'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom';

const KatalogProgramPage = () => {

    const location = useLocation();

    const [catalogPrograms, setCatalogPrograms] = useState([])
    const [programCategory, setprogramCategory] = useState(1)

    const dispatch = useDispatch()
    const dataInputRegistration = useSelector(state => state.dataInputRegistration)
    const handleChangeFormInput = (e) => {
        dispatch({ type: 'SET_SEARCH_PROGRAM', 'value': e.target.value });
    }

    const handleClickTab = (e) => {
        // console.log(e)
        setprogramCategory(e)
    }

    const fetchCatalogPrograms = async () => {
        try {
            const options = {
                url: '/users/programs',
                method: 'GET'
            }
            const { data } = await axios(options)
            // console.log(data)
            setCatalogPrograms(data.data)

        } catch (err) {
            if (err) {
                console.log(err?.response?.data)
                errorHandler({ err: err?.response?.data || err })
            }
        }
    }

    const fetchUserByToken = async () => {
        try {
            const options = {
                url: `/users/users`,
                method: 'GET',
                headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` },
            }
            const { data } = await axios(options)
            dispatch({ type: 'SET_CATEGORY_USER', 'category': data?.data?.Account?.type })

            dispatch({ type: 'SET_NAMADEPAN_PIC', 'namaDepanPic': data?.data?.firstName })
            dispatch({ type: 'SET_NAMABELAKANG_PIC', 'namaBelakangPic': data?.data?.lastName })
            dispatch({ type: 'SET_EMAIL_PIC', 'emailPic': data?.data?.email })
        } catch (err) {
            errorHandler({ err: err?.response?.data || err })
        }
    }

    useEffect(() => {
        fetchCatalogPrograms()
        fetchUserByToken()
    }, [])

    useEffect(() => {
        window.dataLayer.push({
            event: 'pageview',
            page: {
            url: window.location.pathname + window.location.search,
            title: document.title
            }
        });
    }, [location]);
    

    return (
        <>
            <h3>Katalog Program</h3>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#" style={{
                        color: '#B5B5C3'
                    }}>Beranda</a></li>
                    <li class="breadcrumb-item active" aria- current="page" style={{
                        color: '#3F4254'
                    }}>Katalog Program</li>
                </ol>
            </nav>
            <div className='row col-lg-5 col-12 mt-3 mb-3'>
                <input type="text" className="form-control form-control form-control" placeholder="Cari Program..." onChange={(e) => handleChangeFormInput(e)} value={dataInputRegistration.searchProgram} />
            </div>
            <div className='row'>
                <Tabs defaultActiveKey="1" className="mb-3" onSelect={(e => handleClickTab(e))}>
                    {
                        catalogPrograms.map(row => (
                            <Tab key={row.id} eventKey={row.id} title={row.label}>
                                <KatalogProgramComp
                                    key={row.id}
                                    programs={row.Programs}
                                    bundlingPrograms={row.BundlingPrograms}
                                    programCategory={programCategory}
                                />
                            </Tab>
                        ))
                    }
                </Tabs>
            </div>
        </>
    )
}

export default KatalogProgramPage
